@import '../Field/field.css';

/**
 * @prop --field-grid-columns: The field layout.
 **/

:host {
    display: block;
    --field-grid-columns: [before] 1fr [input] 18px [label] 311px [after] 1fr;
}

.input {
    visibility: hidden;

    &:checked ~ .checkbox {
        color: var(--color-secondary);
    }

    &:disabled ~ .checkbox {
        border-color: var(--color-shade-20);
        background-color: var(--color-shade-20);
    }
}

.checkbox {
    grid-column-start: input;
    grid-column-end: input;
    color: transparent;

    border-width: 1px;
    border-style: solid;
    border-color: var(--color-shade-50);
    border-radius: 4px;
    height: 18px;
    width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-property: color, border-color, background-color;
    transition-duration: 500ms;
    transition-timing-function: ease;
}

.label {
    text-align: left;
    grid-column-start: label;
    grid-column-end: after;
}

.field {
    &:focus {
        outline: none;
    }

    &:focus-visible .checkbox {
        box-shadow: 0 0 0px 1px var(--color-secondary);
    }
}

.invalid {
    & .checkbox {
        border-color: var(--color-error);
    }
}
